import { nesaTestnet } from "app/config/chains";

export const getChainById = (chainId?: string) => {
  if (chainId === nesaTestnet.chainId) {
    return nesaTestnet;
  }

  return nesaTestnet;
};
